var _excluded = ["items", "transformItems"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useHitsPerPage } from 'react-instantsearch-core';
import { HitsPerPage as HitsPerPageUiComponent } from "../ui/HitsPerPage.js";
export function HitsPerPage(_ref) {
  var userItems = _ref.items,
    transformItems = _ref.transformItems,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useHitsPerPage = useHitsPerPage({
      items: userItems,
      transformItems: transformItems
    }, {
      $$widgetType: 'ais.hitsPerPage'
    }),
    items = _useHitsPerPage.items,
    refine = _useHitsPerPage.refine;
  var _ref2 = items.find(function (_ref3) {
      var isRefined = _ref3.isRefined;
      return isRefined;
    }) || {},
    currentValue = _ref2.value;
  var uiProps = {
    items: items,
    currentValue: currentValue,
    onChange: function onChange(value) {
      return refine(value);
    }
  };
  return /*#__PURE__*/React.createElement(HitsPerPageUiComponent, _extends({}, props, uiProps));
}